exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#searchContacts_dropdown.angucomplete-dropdown{margin-top:0!important}#searchContacts_dropdown{width:500px}.rounded{border-radius:10px}.mt-20{margin-bottom:40px!important}.text-right{align:right}.text-center{align:center}#searchProducts_dropdown.angucomplete-dropdown{margin-top:0!important}#searchProducts_dropdown{width:500px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/components/accounting/editInvoice/editInvoice.styl
// module id = 1881
// module chunks = 0